import React from "react";
import PhoneInput from "react-phone-input-2";
import "react-phone-input-2/lib/style.css";
import { commonStyles } from "../../../../assets/MUIStyles/commonStyles";

const PhoneInputs = ({ disabled, handleChange, value }) => {
  return (
    <PhoneInput
      disabled={disabled}
      specialLabel={""}
      country={"us"}
      onChange={handleChange}
      value={value}
      enableLongNumbers={true}
      inputProps={{
        name: "phone",
        required: true,
      }}
      buttonStyle={commonStyles.phoneInput.buttonStyle}
      inputStyle={commonStyles.phoneInput.inputStyle}
      containerStyle={commonStyles.phoneInput.containerStyle}
    />
  );
};

export default PhoneInputs;
